import {useState} from 'react'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Button from 'react-bootstrap/Button'

const ConfirmButton = ({initText,cancelText,confirmText,onConfirm,initVariant,confirmVariant,size="sm",disabled,pending=false,className})=>{
	const [step,setStep] = useState('init')
	return ( step==='init'? 
		<Button className={className} disabled={disabled} onClick={()=>{setStep('confirm')}} variant={initVariant} size={size}>
			{initText}
		</Button>
		:
		<ButtonGroup className={className}  size={size}>
			<Button disabled={disabled} onClick={()=>{setStep('init')}} variant="outline-secondary">
				{cancelText}
			</Button>
			<Button 
				disabled={disabled}
				onClick={()=>{
					setStep('cancel')
					onConfirm()
				}}
				variant={confirmVariant}
			>
				{confirmText}
			</Button>
		</ButtonGroup>
	)
}

export default ConfirmButton